/*
  Order-bron als cart-attributen — Sableau

  Sinds de checkout bij Lasso draait (07-09-2026) maakt Lasso de Shopify-order via zijn app.
  Shopify's eigen bron-registratie (customer journey, sessies → checkout) staat daardoor op nul en
  alleen orders waar Lasso toevallig utm's in de URL zag, dragen een bron. Lasso kopieert
  cart-attributen wél één-op-één naar de order (bewezen: __essential_cart_* staat op elke order).

  Dus: utm_*, ttclid/fbclid en de verwijzer bij binnenkomst onthouden (last click, 30 dagen) en
  1) als verborgen velden in elk add-to-cart-formulier stoppen — dan reizen ze vanaf de eerste
     add mee met de winkelwagen, zonder extra verzoek;
  2) één keer per sessie de bestaande winkelwagen bijwerken, voor adds die niet via een formulier
     gaan (quick-add, app-drawer).
  Attributen beginnen met een underscore: Shopify en Lasso tonen die niet aan de klant.
*/
(function () {
  'use strict';

  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ttclid', 'fbclid'];
  var STORE = 'sableau:source';
  var TTL_MS = 30 * 24 * 3600 * 1000;

  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE) || 'null');
      return v && v.ts && Date.now() - v.ts < TTL_MS ? v : null;
    } catch (e) { return null; }
  }

  function capture() {
    var search = location.search;
    try { search = sessionStorage.getItem('sableau:landing-search') || search; } catch (e) {}
    var q = new URLSearchParams(search);
    var out = {}, hit = false;
    KEYS.forEach(function (k) { var v = q.get(k); if (v) { out[k] = String(v).slice(0, 120); hit = true; } });
    if (!out.ttclid) {
      var m = document.cookie.match(/(?:^|;\s*)ttclid=([^;]+)/);
      if (m) { out.ttclid = decodeURIComponent(m[1]).slice(0, 120); hit = true; }
    }
    if (!hit) {
      var ref = document.referrer;
      if (ref && ref.indexOf('//' + location.host) === -1) {
        try { out.utm_source = new URL(ref).hostname.replace(/^www\./, ''); out.utm_medium = 'referral'; hit = true; } catch (e) {}
      }
    }
    if (!hit) return load();
    try { sessionStorage.removeItem('sableau:landing-search'); } catch (e) {}
    out.landing = location.pathname.slice(0, 120);
    out.ts = Date.now();
    try { localStorage.setItem(STORE, JSON.stringify(out)); } catch (e) {}
    return out;
  }

  // Wallet-bereik meten (11-09-2026). Apple Pay was 39,7 % van de 451 orders uit de periode dat élke
  // methode nog kon, dus de hele checkout is erop gebouwd — maar Apple Pay op het web bestaat alleen
  // in Safari. In de in-app browser van TikTok (een WKWebView zonder Apple Pay-entitlement) verschijnt
  // de knop niet, en 94,8 % van ons verkeer is mobiel en komt uit TikTok-advertenties. Whop's API kan
  // het ons niet vertellen: `payment_instrument` was leeg op alle 86 betalingen. Deze twee attributen
  // reizen met de winkelwagen mee naar de order, zodat we per order kunnen tellen wie de knop
  // überhaupt kón zien, in plaats van erover te gokken.
  function walletSupport() {
    var out = [];
    try { if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) out.push('applepay'); } catch (e) {}
    if (window.PaymentRequest) out.push('paymentrequest');
    return out.join('+') || 'none';
  }

  /* Welke checkout-deur deze bezoeker kreeg, en op welk land die keuze is gebaseerd (12-09-2026).
     snippets/payment-route.liquid kiest op `localization.country.iso_code` — de markt-/keuzelandcode, niet het
     bezorgadres. Een Noorse klant die op een EUR-markt binnenkomt, krijgt dus de Whop-deur en precies de
     kaartweigering waar de splitsing voor gemaakt is. Dat is niet in Liquid op te lossen (op de winkelwagen
     bestaat het bezorgadres nog niet), maar het is wél te meten: deze twee attributen reizen met de order mee,
     zodat je achteraf deur × land × weigering naast elkaar kunt leggen. De deur lezen we aan het enige harde
     bewijs op de pagina: staat het Lasso-script er, dan gaat de afrekenknop naar Whop. */
  function checkoutRoute() {
    return document.querySelector('script[src*="lasso-script"]') ? 'whop' : 'revolut';
  }

  function marketCountry() {
    try { return (window.Shopify && window.Shopify.country) || ''; } catch (e) { return ''; }
  }

  function browserKind() {
    var ua = navigator.userAgent || '';
    if (/BytedanceWebview|musical_ly|TikTok|Bytedance/i.test(ua)) return 'tiktok-inapp';
    if (/Instagram/i.test(ua)) return 'instagram-inapp';
    if (/FBAN|FBAV|FB_IAB/i.test(ua)) return 'facebook-inapp';
    if (/Snapchat/i.test(ua)) return 'snapchat-inapp';
    return 'browser';
  }

  var src = capture();

  var attrs = {};
  if (src) Object.keys(src).forEach(function (k) { if (k !== 'ts') attrs['_' + k] = String(src[k]); });
  attrs._wallet = walletSupport();
  attrs._browser = browserKind();
  attrs._route = checkoutRoute();
  attrs._market = marketCountry();

  // 1) verborgen velden. Het thema (Horizon) bindt zijn eigen submit-handler via delegatie op
  //    document in de capture-fase, vóór dit script; een submit-listener komt dus te laat. De
  //    klik op de knop gaat eraan vooraf — daar de velden zetten, zodat ook later ingevoegde
  //    formulieren (quick-add, sticky bar) meegaan.
  function decorate(form) {
    if (!form || form.__sbSource) return;
    if (String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    form.__sbSource = true;
    Object.keys(attrs).forEach(function (k) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + k + ']';
      input.value = attrs[k];
      form.appendChild(input);
    });
  }
  document.addEventListener('click', function (event) {
    var t = event.target instanceof Element ? event.target : null;
    var button = t && t.closest('button, input[type="submit"]');
    if (!button) return;
    decorate(button.form || button.closest('form'));
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target instanceof HTMLFormElement) decorate(event.target);
  }, true);

  // 2) bestaande winkelwagen één keer per sessie bijwerken.
  function synced(v) { try { if (v === undefined) return sessionStorage.getItem(STORE + ':synced') === '1'; sessionStorage.setItem(STORE + ':synced', '1'); } catch (e) { return false; } }
  function sync() {
    if (synced()) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        var have = cart.attributes || {};
        // Marker "al bijgewerkt" = het jóngste attribuut dat we schrijven, nu `_route` (12-09-2026).
        // Stond op `_browser`; een winkelwagen van tussen 11-09 en 12-09 had dat wél en zou de nieuwe
        // deur-/marktvelden dus nooit meer krijgen. De marker moet meeschuiven met wat we toevoegen.
        if (have._route) { synced(true); return; }
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs }),
        }).then(function () { synced(true); });
      })
      .catch(function () {});
  }
  if (document.readyState === 'complete') sync();
  else window.addEventListener('load', sync, { once: true });
})();
